export enum TrackerOriginEnum {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  GOOGLE = "GOOGLE",
  WHATSAPP = "WHATSAPP",
  LINKEDIN = "LINKEDIN",
  TIKTOK = "TIKTOK",
  WEBHOOK = "WEBHOOK",
  OTHER = "OTHER",
}
